export default __webpack_public_path__ + "static/media/Japan_Particle_0006_Tenko_Blast2.c844a287.png";